import { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const button: ButtonDesignTokens = {
  root: {
    borderRadius: '1rem',
    // padding: {
    //   x: '1.25rem',
    //   y: '0.5rem',
    // },
  },
  colorScheme: {
    light: {
      root: {
        contrast: {
          background: '{accent.color}',
          hoverBackground: '{accent.hover.color}',
          activeBackground: '{accent.active.color}',
          borderColor: '{accent.color}',
          hoverBorderColor: '{accent.hover.color}',
          activeBorderColor: '{accent.active.color}',
          color: '{accent.contrast.color}',
          hoverColor: '{accent.contrast.color}',
          activeColor: '{accent.contrast.color}',
          focusRing: {
            color: '{accent.color}',
            shadow: 'none',
          },
        },
        danger: {
          background: '{danger.color}',
          hoverBackground: '{danger.hover.color}',
          activeBackground: '{danger.active.color}',
        },
      },
    },
  },
};
